import { miscHelpers, routerHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';

import { showSignupModule } from '../actions';
import { SIGN_UP_PAGE_ID } from '../config';

const useSignUpPageData = () => {
    const dispatch = useDispatch();
    const authenticated = useSelector(selectors.session.authenticated);
    const search = useLocation().search;

    const email = routerHelpers.getParamAsString(search, 'email', '');
    const token = routerHelpers.getParamAsString(search, 'token', '');
    const initialApp = routerHelpers.getParamAsString(search, 'app', '');
    const app = miscHelpers.castToEnum(domain.SsoLoginApplication, initialApp);

    useEffect(() => {
        if (authenticated) {
            routingService.replaceToDefaultPath();
        } else {
            dispatch(showSignupModule(email, token, app, SIGN_UP_PAGE_ID));
        }
    }, [authenticated, dispatch, email, app, token]);
};

export default useSignUpPageData;
